module.exports = __webpack_public_path__ + "images/letter-button-faded.png";